import * as moment from 'moment';
import { IXmTracking } from '@nkr/models/xm-tracking';
import { Button, Modal, Table } from 'react-bootstrap';
import styled from 'styled-components';

const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IProps {
    show: boolean,
    data: IXmTracking,
    onCancel: () => void
}

const DetailsModal = (props: IProps) => {
    if (props.data == null)
        return null;

    return (
        <Modal show={props.show} bsSize="large" backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>XM Tracking Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableWrapper>
                    <thead>
                        <tr>
                            <th>Date Requested</th>
                            <th>Date Shipped Out</th>
                            <th>Date Shipped Back</th>
                            <th>Date Received</th>
                            <th>Date Results Due</th>
                            <th>Date Results Recorded</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {props.data.requestedDate != null ? moment(props.data.requestedDate).format('MM/DD/YYYY') : ''}
                            </td>
                            <td>
                                {props.data.shipOutDate != null ? moment(props.data.shipOutDate).format('MM/DD/YYYY') : ''}
                            </td>
                            <td>
                                {props.data.shipBackDate != null ? moment(props.data.shipBackDate).format('MM/DD/YYYY') : ''}
                            </td>
                            <td>
                                {props.data.receivedDate != null ? moment(props.data.receivedDate).format('MM/DD/YYYY') : ''}
                            </td>
                            <td>
                                {props.data.dateResultsDue != null ? moment(props.data.dateResultsDue).format('MM/DD/YYYY') : ''}
                            </td>
                            <td>
                                {props.data.resultsRecordedDate != null ? moment(props.data.resultsRecordedDate).format('MM/DD/YYYY') : ''}
                            </td>
                        </tr>

                    </tbody>
                </TableWrapper>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DetailsModal;